<template>
  <v-navigation-drawer
    bottom
    color="transparent"
    fixed
    height="auto"
    overlay-color="secondary"
    overlay-opacity=".8"
    temporary
    v-bind="$attrs"
    v-on="$listeners"
  >
    <v-list
      color="white"
      shaped
    >
      <v-list-item
        v-for="el in items"
        :key="el.name"
        :exact="el.name === 'Home'"
        color="primary"
        @click="$vuetify.goTo(el.link, options)"
      >
        <v-list-item-content>
          <v-list-item-title v-text="el.name" />
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
  export default {
    name: 'HomeDrawer',

    props: {
      options : {
        type: Object,
        default: () => ({
          duration: 300,
          offset: 0,
          easing: 'easeInOutCubic'
        }),
      },
      items: {
        type: Array,
        default: () => ([]),
      },
    },
  }
</script>
